import React, { useState, useEffect } from "react";
import { Form, Row, Col, Input, Select, TimePicker, InputNumber } from "antd";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import {
  dosageTiming,
  medicineFormOptions,
  medicineFrequency,
  medicineRoutes,
} from "../../../../helpers/medicineKeys";
import dayjs from "dayjs";

const { Option } = Select;

const format = "hh A";

const defaultTimes = {
  Once_Daily: ["08 AM"],
  Twice_Daily: ["08 AM", "08 PM"],
  Thrice_Daily: ["08 AM", "01 PM", "08 PM"],
  Four_Times_Daily: ["08 AM", "01 PM", "04 PM", "08 PM"],
};

const AiMedicineAddForm = ({
  form,
  selectedFrequency,
  setSelectedFrequency,
  editData,
}) => {
  const [selectedForm, setSelectedForm] = useState(null);
  const [times, setTimes] = useState([]);

  useEffect(() => {
    if (editData?.name) {
      form.setFieldsValue({
        ...editData,
        name: editData?.name,
        duration: editData?.duration,
        comments: editData?.comments,
      });

      if (editData?.frequency) {
        setSelectedFrequency(editData.frequency);

        const defaultTimeValues = defaultTimes[editData.frequency] || [];
        setTimes(defaultTimeValues.map((t) => dayjs(t, format)));

        form.setFieldsValue({
          schedule: { times: defaultTimeValues.map((t) => dayjs(t, format)) },
        });
      }
    }
  }, [editData?.name]);

  const handleFrequencyChange = (value) => {
    setSelectedFrequency(value);
    const defaultTimeValues = defaultTimes[value] || [];
    setTimes(defaultTimeValues.map((time) => dayjs(time, format)));
    form.setFieldsValue({
      schedule: { times: defaultTimeValues.map((time) => dayjs(time, format)) },
    });
  };
  const handleTimeChange = (time, index) => {
    const newTimes = [...times];
    newTimes[index] = time;
    setTimes(newTimes);
    form.setFieldsValue({
      schedule: { times: newTimes },
    });
  };

  const renderTimePickers = () => {
    let numPickers = 0;

    if (selectedFrequency === "Once_Daily") {
      numPickers = 1;
    } else if (selectedFrequency === "Twice_Daily") {
      numPickers = 2;
    } else if (selectedFrequency === "Thrice_Daily") {
      numPickers = 3;
    } else if (selectedFrequency === "Four_Times_Daily") {
      numPickers = 4;
    }

    const timePickers = Array.from({ length: numPickers }, (_, index) => (
      <Col span={12} key={index}>
        <Form.Item
          name={["schedule", "times", index]}
          rules={[{ required: true, message: "Please select times" }]}
        >
          <TimePicker
            inputReadOnly
            needConfirm={false}
            value={times[index]}
            format={format}
            onChange={(time) => handleTimeChange(time, index)}
          />
        </Form.Item>
      </Col>
    ));

    return (
      <Row gutter={[8, 8]} style={{}}>
        {timePickers}
      </Row>
    );
  };
  return (
    <Row gutter={16}>
      <Col span={8}>
        <Form.Item
          label="Medicine Name"
          name="name"
          style={{ width: "100%" }}
          rules={[{ required: true, message: "Enter Medicine Name" }]}
        >
          <Input placeholder="Name" className={inputStyles.mdInput} />
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item label="Drug" name="drug">
          <Input placeholder="Enter Drug" className={inputStyles.mdInput} />
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item label="Dose" name="dose">
          <Input
            placeholder="Dose"
            className={`${inputStyles.mdInput}`}
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item label="Form" name="form">
          <Select
            placeholder="Choose Form"
            onChange={(value) => setSelectedForm(value)}
            style={{ width: "100%" }}
            className={inputStyles.mdSelect}
          >
            {medicineFormOptions?.map((item) => (
              <Option value={item?.value} key={item?.value}>
                {item?.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
        {selectedForm === "Others" && (
          <Form.Item
            label="Other Form"
            labelCol={{ span: 24 }}
            name="other_form"
            rules={[{ required: true, message: "Please enter form name" }]}
          >
            <Input
              placeholder="Enter other form"
              className={inputStyles.mdInput}
              style={{ width: "100%" }}
            />
          </Form.Item>
        )}
      </Col>

      <Col span={8}>
        <Form.Item
          label="Frequency"
          name="frequency"
          rules={[{ required: true, message: "Enter Frequency" }]}
        >
          <Select
            style={{ width: "100%" }}
            className={inputStyles.mdSelect}
            onChange={handleFrequencyChange}
          >
            {medicineFrequency?.map((item) => (
              <Option value={item?.value} key={item?.value}>
                {item?.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <>{renderTimePickers()}</>
      </Col>

      <Col span={8}>
        <Form.Item label="Route" name="route">
          <Select
            allowClear
            className={inputStyles.mdSelect}
            style={{ width: "100%" }}
            placeholder="Route"
          >
            {medicineRoutes?.map((item) => (
              <Option value={item?.value} key={item?.value}>
                {item?.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item label="Duration" name="duration">
          <InputNumber
            placeholder="Enter Duration"
            style={{ width: "100%" }}
            className={inputStyles.mdNumberInput}
          />
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item label="Timing" labelCol={{ span: 24 }} name="dosage_timing">
          <Select
            allowClear
            style={{ width: "100%" }}
            className={inputStyles.mdSelect}
            placeholder="Timing"
          >
            {dosageTiming?.map((item) => (
              <Option value={item?.value} key={item?.value}>
                {item?.title}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item label="Notes" name="comments">
          <Input.TextArea
            placeholder="Comments"
            className={inputStyles.mdInput}
            rows={2}
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default AiMedicineAddForm;
